/*--------------------------------------------------------------
# Custom scripts for Columns Slider block
--------------------------------------------------------------*/

// 1 column default
const testiSlider = document.querySelectorAll('.testimonial-feed.testimonial-cards--1col .testimonial-slider .swiper');
const testiSliderPagination = document.querySelectorAll('.testimonial-feed.testimonial-cards--1col .testi-swiper-pagination');
const testiSliderNext = document.querySelectorAll('.testimonial-feed.testimonial-cards--1col .testi-swiper-next');
const testiSliderPrev = document.querySelectorAll('.testimonial-feed.testimonial-cards--1col .testi-swiper-prev');

for( i = 0; i < testiSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    testiSlider[i].classList.add('swiper-' + i);
    testiSliderPagination[i].classList.add('testi-swiper-pagination-' + i); 
    testiSliderNext[i].classList.add('testi-swiper-next-' + i);
    testiSliderPrev[i].classList.add('testi-swiper-prev-' + i);

    var initTestiSlider = new Swiper('.testimonial-feed.testimonial-cards--1col .testimonial-slider .swiper-' + i, {
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
        },
        // Pagination toggle buttons
        pagination: {
            el: '.testimonial-feed.testimonial-cards--1col .testi-swiper-pagination-' + i,
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.testimonial-feed.testimonial-cards--1col .testi-swiper-next-' + i,
            prevEl: '.testimonial-feed.testimonial-cards--1col .testi-swiper-prev-' + i,
        },
    });
}

// 2 column choice
const testiSliderTwoCol = document.querySelectorAll('.testimonial-feed.testimonial-cards--2col .testimonial-slider .swiper');
const testiSliderTwoColPagination = document.querySelectorAll('.testimonial-feed.testimonial-cards--2col .testi-swiper-pagination');
const testiSliderTwoColNext = document.querySelectorAll('.testimonial-feed.testimonial-cards--2col .testi-swiper-next');
const testiSliderTwoColPrev = document.querySelectorAll('.testimonial-feed.testimonial-cards--2col .testi-swiper-prev');

for( i = 0; i < testiSliderTwoCol.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    testiSliderTwoCol[i].classList.add('swiper-' + i);
    testiSliderTwoColPagination[i].classList.add('testi-swiper-pagination-' + i); 
    testiSliderTwoColNext[i].classList.add('testi-swiper-next-' + i);
    testiSliderTwoColPrev[i].classList.add('testi-swiper-prev-' + i);

    var initTestiSlider = new Swiper('.testimonial-feed.testimonial-cards--2col .testimonial-slider .swiper-' + i, {
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
        },
        // Pagination toggle buttons
        pagination: {
            el: '.testimonial-feed.testimonial-cards--2col .testi-swiper-pagination-' + i,
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.testimonial-feed.testimonial-cards--2col .testi-swiper-next-' + i,
            prevEl: '.testimonial-feed.testimonial-cards--2col .testi-swiper-prev-' + i,
        },
        breakpoints: {
            748: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
        }
    });
}

// 3 column choice
const testiSliderThreeCol = document.querySelectorAll('.testimonial-feed.testimonial-cards--3col .testimonial-slider .swiper');
const testiSliderThreeColPagination = document.querySelectorAll('.testimonial-feed.testimonial-cards--3col .testi-swiper-pagination');
const testiSliderThreeColNext = document.querySelectorAll('.testimonial-feed.testimonial-cards--3col .testi-swiper-next');
const testiSliderThreeColPrev = document.querySelectorAll('.testimonial-feed.testimonial-cards--3col .testi-swiper-prev');

for( i = 0; i < testiSliderThreeCol.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    testiSliderThreeCol[i].classList.add('swiper-' + i);
    testiSliderThreeColPagination[i].classList.add('testi-swiper-pagination-' + i); 
    testiSliderThreeColNext[i].classList.add('testi-swiper-next-' + i);
    testiSliderThreeColPrev[i].classList.add('testi-swiper-prev-' + i);

    var initTestiSlider = new Swiper('.testimonial-feed.testimonial-cards--3col .testimonial-slider .swiper-' + i, {
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
        },
        // Pagination toggle buttons
        pagination: {
            el: '.testimonial-feed.testimonial-cards--3col .testi-swiper-pagination-' + i,
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.testimonial-feed.testimonial-cards--3col .testi-swiper-next-' + i,
            prevEl: '.testimonial-feed.testimonial-cards--3col .testi-swiper-prev-' + i,
        },
        breakpoints: {
            748: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            992: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        }
    });
}
